import './App.scss';
import Form from './components/Form'
import { Col, Row } from './components/Bootstrap'

function App() {
  return (
    <>
      <header>
        <div className="container border-bottom py-4">
          <Row>
            <Col>
              <h1 className="text-center">Wood cut calculator</h1>
            </Col>
          </Row>
        </div>
      </header>
      <main className="container border-bottom py-4">
        <p>
          Use the form below to calculate how many boards you'll need to buy
          to make the desired number of cuts
        </p>
        <Form />
      </main>
      <footer className="py-4">
        <div className="container">
          <Row>
            <Col>
              By <a href="https://gavinmorrice.com">Gavin Morrice</a>
            </Col>
          </Row>
        </div>
      </footer>
    </>
  );
}

export default App;
